import { render, staticRenderFns } from "./mandarin.vue?vue&type=template&id=97d73994&scoped=true"
import script from "./mandarin.vue?vue&type=script&lang=ts"
export * from "./mandarin.vue?vue&type=script&lang=ts"
import style0 from "./mandarin.vue?vue&type=style&index=0&id=97d73994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d73994",
  null
  
)

export default component.exports